<!-- Parking Space Container -->
@for (parkingSpace of parkingSpaces; track parkingSpace.id) {
<app-parking-space-item [parkingSpace]="parkingSpace"
    (parkingSpaceDeleted)="onParkingSpaceDeleted($event)"></app-parking-space-item>
}

@if (!parkingSpaces || parkingSpaces.length === 0) {
<div class="text-center py-8 text-gray-500">No parking spaces found.</div>
}

<!-- JJames Enhanced Pagination Component -->
@if (jjamesPaginationConfig) {
<jjames-paginator [config]="jjamesPaginationConfig" [showFirstLastButtons]="true"
    [ariaLabel]="'Navigate parking space pages'" (pageChange)="onPageChange($event)">
</jjames-paginator>
}